<template>
  <div>
    <div class="page flex ai-s">
      <div class="leftBox">
        <div v-if="detailInfo != null">
          <div class="prediction flex">
            <div class="predictionBox" :class="detailInfo.wdlModel.hasOwnProperty('diffBaseInfo') == false ? 'only' : ''" v-if="detailInfo.wdlModel.hasOwnProperty('marginBaseInfo')">
              <div class="head flex flex-pack-justify flex-align-center">
                <div class="flex flex-align-center">
                  <i class="marginIcon" />
                  <div class="title">Margin Predicted Match Results</div>
                </div>
                <i class="queryIcon" @click="showPopup('margin')"/>
              </div>
              <div class="resultsBox">
                <div class="teamBox flex flex-align-center" :class="(match.state == 4 && detailInfo.wdlModel.marginBaseInfo.hit == 1) ? 'endHit' : (match.state == 4 && detailInfo.wdlModel.marginBaseInfo.hit != 1 ? 'endNoHit' : '')">
                  <div class="teamName">{{detailInfo.wdlModel.marginBaseInfo.hasOwnProperty('winRecommend') ? detailInfo.match.homeTeam.shortName : (detailInfo.wdlModel.marginBaseInfo.hasOwnProperty('lossRecommend') ? detailInfo.match.awayTeam.shortName : 'Draw')}}</div>
                  <div class="flex flex-align-center">
                    <div class="star flex" :class="'star'+(detailInfo.wdlModel.confidence * 2)"  v-if="detailInfo.wdlModel.hasOwnProperty('confidence')">
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                      <i></i>
                    </div>
                    <i v-if="detailInfo.wdlModel.marginBaseInfo.hit == 1" class="active"/>
                  </div>
                </div>
                <div class="flex flex-pack-justify flex-align-center">
                  <div class="flex oddsBox">
                    <div class="typeName"><span>1x2</span></div>
                    <div class="win"><span>{{oddsCallFn(1, detailInfo.wdlModel.marginBaseInfo.win, 'home')}}</span></div>
                    <div class="draw"><span>{{oddsCallFn(1, detailInfo.wdlModel.marginBaseInfo.draw, 'draw')}}</span></div>
                    <div class="lose"><span>{{oddsCallFn(1, detailInfo.wdlModel.marginBaseInfo.loss, 'away')}}</span></div>
                  </div>
                  <div class="updataTime" @click="changePup('margin')">{{getGameTime(detailInfo.wdlModel.maginUpdateTime,'dd MM ,HH:mm')}} Updated</div>
                </div>
              </div>
            </div>
            <div class="predictionBox" :class="detailInfo.wdlModel.hasOwnProperty('marginBaseInfo') == false ? 'only' : ''" v-if="detailInfo.wdlModel.hasOwnProperty('diffBaseInfo')">
              <div class="head flex flex-pack-justify flex flex-align-center">
                <div class="flex flex-align-center">
                  <i class="divergenceIcon" />
                  <div class="title">Divergence Predicted Match Results</div>
                </div>
                <i class="queryIcon" @click="showPopup('divergence')"/>
              </div>
              <div class="resultsBox">
                <div class="teamBox flex flex-align-center" :class="(match.state == 4 && detailInfo.wdlModel.diffBaseInfo.wdlHit == 1) ? 'endHit' : (match.state == 4 && detailInfo.wdlModel.diffBaseInfo.wdlHit != 1) ? 'endNoHit' : ''">
                  <div class="teamName txt-c">{{ detailInfo.wdlModel.diffBaseInfo.wdl == 1 ? detailInfo.match.homeTeam.shortName : (detailInfo.wdlModel.diffBaseInfo.wdl == 2 ? 'Draw' : detailInfo.match.awayTeam.shortName)}}</div>
                  <i v-if="detailInfo.wdlModel.diffBaseInfo.hasOwnProperty('wdlHit') && detailInfo.wdlModel.diffBaseInfo.wdlHit == 1" class="active"/>
                </div>
                <div class="txt-r"><span class="updataTime" @click="changePup('divergence')">{{getGameTime(detailInfo.wdlModel.diffUpdateTime,'dd MM ,HH:mm')}} Updated</span></div>
              </div>
            </div>
          </div>
          <div class="logged" style="clear: both" v-if="isLogin == true || match.state == 4">
            <!-- 指数走势 -->
            <div class="oddsTrend" v-if="detailInfo.wdlModel.hasOwnProperty('oddsTrend')">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">Odds Trend</div>
                <ul class="radio flex flex-align-center">
                  <li @click="changeType(1)" :class="isDay == 1 ? 'active' : ''">Date</li>
                  <li @click="changeType(0)" :class="isDay == 0 ? 'active' : ''" v-if="detailInfo.wdlModel.oddsTrend.time.length > 0">24H</li>
                </ul>
              </div>
              <div class="oddsTrendBox">
                <div class="container">
                  <div class="flex flex-pack-justify flex-align-center">
                    <div class="tip">
                      Initial  
                      <span class="home">{{ oddsCallFn(1, detailInfo.wdlModel.oddsTrend['day'][0].home, 'home') }}</span> | 
                      <span class="draw">{{ oddsCallFn(1, detailInfo.wdlModel.oddsTrend['day'][0].draw, 'draw') }}</span> | 
                      <span class="away">{{oddsCallFn(1, detailInfo.wdlModel.oddsTrend['day'][0].away, 'away')}}</span>
                    </div>
                    <div class="tip">Live 
                      <span class="home">{{oddsCallFn(1, detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].home, 'home')}}</span> | 
                      <span class="draw">{{oddsCallFn(1, detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].draw, 'draw')}}</span> | 
                      <span class="away">{{oddsCallFn(1, detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'][detailInfo.wdlModel.oddsTrend[isDay == 1 ? 'day' : 'time'].length-1].away, 'away')}}</span>
                    </div>
                  </div>
                  <div ref="lineEchart" class="lineEchart"></div>
                </div>
                <div class="flex wdl flex-pack-center">
                  <div class="win">Home</div>
                  <div class="draw">Draw</div>
                  <div class="lose">Away</div>
                </div>
              </div>
            </div>

            <!-- Divergence 演算数据 -->
            <div class="module divergence" :class="detailInfo.wdlModel.hasOwnProperty('marginBaseInfo') == false ? 'only' : ''" v-if="detailInfo.wdlModel.hasOwnProperty('wplRes')">
              <div class="title">Divergence calculation data</div>
              <div class="box">
                <ul class="flex">
                  <li class="flex1">
                    <div class="head">Options</div>
                    <div class="body"><b>1</b></div>
                    <div class="body"><b>X</b></div>
                    <div class="body"><b>2</b></div>
                  </li>
                  <li class="flex1">
                    <div class="head">Probability</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.homeRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.drawRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.awayRes || '&nbsp;'}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Bookmakers</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.compHomeRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.compDrawRes || '&nbsp;'}}</div>
                    <div class="body">{{detailInfo.wdlModel.wplRes.compAwayRes || '&nbsp;'}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Divergence</div>
                    <div class="body">{{Math.abs(detailInfo.wdlModel.wplRes.homeDiff.split('%')[0])}}</div>
                    <div class="body">{{Math.abs(detailInfo.wdlModel.wplRes.drawDiff.split('%')[0])}}</div>
                    <div class="body">{{Math.abs(detailInfo.wdlModel.wplRes.awayDiff.split('%')[0])}}</div>
                  </li>
                  <li class="flex1">
                    <div class="head">Pick</div>
                    <div class="suggestion" :class="(match.state == 4 && detailInfo.wdlModel.diffBaseInfo.wdlHit == 1) ? 'endHit active' : (match.state == 4 && detailInfo.wdlModel.diffBaseInfo.wdlHit != 1) ? 'endNoHit' : ''">
                      {{detailInfo.wdlModel.wplRes.predict == 1 ? 1 : (detailInfo.wdlModel.wplRes.predict == 3 ? 2 : 'X')}}
                    </div>
                    <!-- <div class="suggestion" :class="detailInfo.wdlModel.baseInfo.hasOwnProperty('wdlHit') && detailInfo.wdlModel.baseInfo.wdlHit == 1 ? 'active' : ''">
                      {{detailInfo.wdlModel.wplRes.predict == 1 ? 1 : (detailInfo.wdlModel.wplRes.predict == 3 ? 2 : 'X')}}
                    </div> -->
                  </li>
                </ul>
              </div>
            </div>
            <!-- last 10 matches -->
            <div class="module last10" :class="detailInfo.wdlModel.hasOwnProperty('marginBaseInfo') == false ? 'only' : ''" v-if="detailInfo.wdlModel.hasOwnProperty('last_10Goals') && JSON.stringify(detailInfo.wdlModel.last_10Goals) != '{}'">
              <div class="title">Home/Away Statistics (Last 10 Matches)</div>
              <div class="box">
                <div class="container">
                  <div class="flex flex-pack-justify">
                    <div class="homeTile"><span>{{ detailInfo.match.homeTeam.shortName }}</span> Home</div>
                    <div class="awayTile"><span>{{ detailInfo.match.awayTeam.shortName }}</span> Away</div>
                  </div>
                  <!-- 进球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.home.goals}}</div>
                      <div class="name">Goals</div>
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.away.goals }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.wdlModel.last_10Goals.home.goals) + Number(detailInfo.wdlModel.last_10Goals.away.goals)), detailInfo.wdlModel.last_10Goals.home.goals) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.wdlModel.last_10Goals.home.goals) + Number(detailInfo.wdlModel.last_10Goals.away.goals)), detailInfo.wdlModel.last_10Goals.away.goals) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 失球数 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.home.loss }}</div>
                      <div class="name">Goals Conceded</div>
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.away.loss }}</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style=" 'width:' + percentageVal((Number(detailInfo.wdlModel.last_10Goals.home.loss) + Number(detailInfo.wdlModel.last_10Goals.away.loss)), Number(detailInfo.wdlModel.last_10Goals.home.loss)) "></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style=" 'width:' + percentageVal((Number(detailInfo.wdlModel.last_10Goals.home.loss) + Number(detailInfo.wdlModel.last_10Goals.away.loss)), Number(detailInfo.wdlModel.last_10Goals.away.loss)) "></div>
                      </div>
                    </div>
                  </div>
                  <!-- 胜率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.home.winPct }}%</div>
                      <div class="name">Win Rate</div>
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.away.winPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.wdlModel.last_10Goals.home.winPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.wdlModel.last_10Goals.away.winPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                  <!-- 赢率 -->
                  <div>
                    <div class="flex flex-pack-justify flex-align-center">
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.home.handicapWinPct }}%</div>
                      <div class="name">Draw Rate</div>
                      <div class="val">{{ detailInfo.wdlModel.last_10Goals.away.handicapWinPct }}%</div>
                    </div>
                    <div class="flex progress">
                      <div class="left" >
                        <div class="left_active" :style="'width:' + detailInfo.wdlModel.last_10Goals.home.handicapWinPct + '%'"></div>
                      </div>
                      <div class="middle"></div>
                      <div class="right">
                        <div class="right_active" :style="'width:' + detailInfo.wdlModel.last_10Goals.away.handicapWinPct + '%'"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 指数公司升降统计（99家） -->
            <div class="liftStatistics" v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat') && detailInfo.wdlModel.hasOwnProperty('diffBaseInfo') == false">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">The stats of {{detailInfo.wdlModel.companyOddsStat.companyCount}} bookmakers</div>
                <div class="rds flex">
                  <div class="rise">Up</div>
                  <div class="drop">Down</div>
                  <div class="stable">Stay</div>
                </div>
              </div>
              <div class="liftStatisticsBox">
                <div class="container">
                  <div class="flex echartList" v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat')">
                    <div class="pieChart" ref="liftStatistics_chart1"></div>
                    <div class="pieChart" ref="liftStatistics_chart2"></div>
                    <div class="pieChart" ref="liftStatistics_chart3"></div>
                  </div>
                  <div v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat')">
                    <div class="flex liftStatisticsLine_rise">
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.home.up ? 'active' : ''">{{getOddsStat(1,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.draw.up ? 'active' : ''">{{getOddsStat(2,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.away.up ? 'active' : ''">{{getOddsStat(3,1)}}% Up</div>
                    </div>
                    <div class="flex liftStatisticsLine_drop">
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.home.down ? 'active' : ''">{{getOddsStat(1,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.draw.down ? 'active' : ''">{{getOddsStat(2,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.away.down ? 'active' : ''">{{getOddsStat(3,2)}}% Down</div>
                    </div>
                    <div class="flex liftStatisticsLine_stable">
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.home.flat ? 'active' : ''">{{getOddsStat(1,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.draw.flat ? 'active' : ''">{{getOddsStat(2,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.away.flat ? 'active' : ''">{{getOddsStat(3,3)}}% Stay</div>
                    </div>
                  </div>
                </div>
                <div class="tip">Note: Down' indicates an increase in hit probability, while 'Up' indicates a decrease in hit probability.</div>
              </div>
            </div>

            <!-- 历史交锋 -->
            <div class="historyClash" v-if="detailInfo.wdlModel.hasOwnProperty('matchLog') && detailInfo.wdlModel.matchLog.list.length > 0">
              <!-- <div class="historyClash" > -->
              <div class="title">Head-to-Head Records</div>
              <div class="historyClashBox">
                <div class="container"  v-if="detailInfo.wdlModel.hasOwnProperty('matchLog')">
                  <div class="flex flex-align-center flex-pack-center relative">
                    <div class="pieChart" ref="historyClash_chart"></div>
                    <ul class="pct ">
                      <li class="winPct">{{getMatchNum('win')}} Win( {{detailInfo.wdlModel.matchLog.win + '%'}} )</li>
                      <li class="drawPct">{{getMatchNum('draw')}} Draw( {{detailInfo.wdlModel.matchLog.draw + '%'}} )</li>
                      <li class="lossPct">{{getMatchNum('loss')}} Loss( {{detailInfo.wdlModel.matchLog.loss + '%'}} )</li>
                    </ul>
                  </div>
                  <ul class="matchList" :class="isDown == false ? '' : 'showAll'">
                    <li class="flex flex-align-center" v-for="(item,index) in detailInfo.wdlModel.matchLog.list" :key="index" >
                      <div class="flex">
                        <div class="league">{{item.leagueName}}</div>
                        <div>{{getMatchTime(Math.floor(new Date(item.time).getTime() / 1000),'dd/MM YYYY')}}</div>
                      </div>
                      <div class="flex flex-align-center">
                        <div class="teamName txt-r" :class="(item.score.split('-')[0] > item.score.split('-')[1] ? 'state_win' : '')">{{getTeamName(item.homeId)}}</div>
                        <div class="score"><span :class="(item.score.split('-')[0] > item.score.split('-')[1] ? 'state_win' : '')">{{item.score.split('-')[0]}}</span>:<span :class="(item.score.split('-')[0] < item.score.split('-')[1] ? 'state_win' : '')">{{item.score.split('-')[1]}}</span></div>
                        <div class="teamName" :class="(item.score.split('-')[0] < item.score.split('-')[1] ? 'state_win' : '')">{{getTeamName(item.awayId)}}</div>
                      </div>
                      <div class="state" :class="getState(item.res,'class')">{{getState(item.res,'title')}}</div>
                    </li>
                  </ul>
                  <div class="down" @click="down()" v-show="isDown == false">
                    <i class="downIcon"></i>
                  </div>
                </div>
                <div class="tip">Note: Win, Draw, and Loss are based on the home team's performance in this matchup.</div>
              </div>
            </div>

            <!-- 指数公司升降统计（99家） -->
            <div class="liftStatistics" v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat') && detailInfo.wdlModel.hasOwnProperty('diffBaseInfo') == true">
              <div class="flex flex-pack-justify flex-align-center">
                <div class="title">The stats of {{detailInfo.wdlModel.companyOddsStat.companyCount}} bookmakers</div>
                <div class="rds flex">
                  <div class="rise">Up</div>
                  <div class="drop">Down</div>
                  <div class="stable">Stay</div>
                </div>
              </div>
              <div class="liftStatisticsBox">
                <div class="container">
                  <div class="flex echartList" v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat')">
                    <div class="pieChart" ref="liftStatistics_chart1"></div>
                    <div class="pieChart" ref="liftStatistics_chart2"></div>
                    <div class="pieChart" ref="liftStatistics_chart3"></div>
                  </div>
                  <div v-if="detailInfo.wdlModel.hasOwnProperty('companyOddsStat')">
                    <div class="flex liftStatisticsLine_rise">
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.home.up ? 'active' : ''">{{getOddsStat(1,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.draw.up ? 'active' : ''">{{getOddsStat(2,1)}}% Up</div>
                      <div class="flex1" :class="getMaxNum('up') == detailInfo.wdlModel.companyOddsStat.away.up ? 'active' : ''">{{getOddsStat(3,1)}}% Up</div>
                    </div>
                    <div class="flex liftStatisticsLine_drop">
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.home.down ? 'active' : ''">{{getOddsStat(1,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.draw.down ? 'active' : ''">{{getOddsStat(2,2)}}% Down</div>
                      <div class="flex1" :class="getMaxNum('down') == detailInfo.wdlModel.companyOddsStat.away.down ? 'active' : ''">{{getOddsStat(3,2)}}% Down</div>
                    </div>
                    <div class="flex liftStatisticsLine_stable">
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.home.flat ? 'active' : ''">{{getOddsStat(1,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.draw.flat ? 'active' : ''">{{getOddsStat(2,3)}}% Stay</div>
                      <div class="flex1" :class="getMaxNum('flat') == detailInfo.wdlModel.companyOddsStat.away.flat ? 'active' : ''">{{getOddsStat(3,3)}}% Stay</div>
                    </div>
                  </div>
                </div>
                <div class="tip">Note: Down' indicates an increase in hit probability, while 'Up' indicates a decrease in hit probability.</div>
              </div>
            </div>

            <!-- <div class="blankBox"></div> -->
            <!-- 历史同指数 -->
            <div class="historySameOdds" v-if="detailInfo.wdlModel.hasOwnProperty('sameOddsHistory') && Object.keys(detailInfo.wdlModel.sameOddsHistory.home).length != 0">
              <div class="title">Historical Performance for Similar Odds</div>
              <div class="historySameOddsBox">
                <div class="container">
                  <div class="subtext">Initial:</div>
                  <ul class="flex">
                    <li class="flex1">
                      <div class="win">
                        <div class="name">1</div> 
                        <div>{{oddsCallFn(1, detailInfo.wdlModel.sameOddsHistory.home.odds, 'home')}}</div>
                      </div>
                      <!-- oddsCallFn(2, detailInfo.wdlModel.sameOddsHistory.away.odds, 'away') -->
                      <div class="pieChart" ref="sameOdds_chart1"></div>
                      <div class="winTitle">{{detailInfo.wdlModel.sameOddsHistory.home.hitCount}} home wins</div>
                    </li>
                    <li class="flex1">
                      <div class="draw">
                        <div class="name">X</div>  
                        <div>{{oddsCallFn(1, detailInfo.wdlModel.sameOddsHistory.draw.odds, 'draw')}}</div>
                      </div>
                      <div class="pieChart" ref="sameOdds_chart2"></div>
                      <div class="drawTitle">{{detailInfo.wdlModel.sameOddsHistory.draw.hitCount}} draws</div>
                    </li>
                    <li class="flex1">
                      <div class="lose">
                        <div class="name">2</div>  
                        <div>{{oddsCallFn(1, detailInfo.wdlModel.sameOddsHistory.away.odds, 'away')}}</div>
                      </div>
                      <div class="pieChart" ref="sameOdds_chart3"></div>
                      <div class="loseTitle">{{detailInfo.wdlModel.sameOddsHistory.away.hitCount}} away wins</div>
                    </li>
                  </ul>
                </div>
                <div class="tip">Note: The probabilities represent the likelihood of each outcome based on historical matches with similar initial odds.</div>
              </div>
            </div>

          </div>

          <!-- 未登录 -->
          <div class="noLogin" v-if="isLogin == false && match.state != 4">
            <!-- <img src="../../../assets/images/noLogin_Bg1.png"> -->
            <div class="noLoginBox">
              <i class="noLoginIcon"></i>
              <p>Log in to view the content.</p>
              <div class="btn" @click="onChangePop({loginShow:true, loginInfoShow:false})">Log in Now</div>
            </div>
          </div>
        </div>
        <div v-else class="noData">
          <div><img src="../../../assets/images/nodata.png" /></div>
          <div class="title">No data</div>
        </div>
      </div>
      <div class="rightBox flex1">
        <div class="title">Additional Matches</div>
        <ul class="list">
          <li v-for="(item,index) in relateMatch" :key="index" @click="changeMatch(item)">
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['homeTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.homeTeam.fullName }}</div>
            </div>
            <div class="flex flex-align-center">
              <div class="logo"><img :src="common.teamImgGet(item['awayTeam']['id'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{ item.awayTeam.fullName }}</div>
            </div>
            <div class="league flex flex-align-center">
              <div class="logo"><img :src="common.leagueImgGet(item['leagueId'])" @error="common.imgError($event, 'team')"  alt=""></div>
              <div class="name">{{relateLeague[item.leagueId]['shortName']}}  {{getGameTime(item.startTime)}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <van-popup class="tipPopup" v-model="tipPopupShow" :position="isWeb?'center':'bottom'" round  get-container="#app">
      <div class="popup_head flex flex-align-center">
        <p class="popup_title">{{ popupType == 'margin' ? 'Margin' : 'Divergence' }} Prediction Instruction</p>
        <i class="popup_close" @click="tipPopupShow = !tipPopupShow"/>
      </div>
      <div class="popup_body">
        <div>
          <div class="popup_body_title">
            {{ popupType == 'margin' ? 'Margin predicted outcome based on bookmaker margin analysis.' : 'Our recommendation based on calculated probabilities and market trends.' }}
          </div>
          <ul>
            <li>
              <div class="list_title">Prediction Result:</div>
              <div>
                <p>Provides a prediction for the 90-minute match outcome, which may include: home win, draw, away win. If the prediction result is a home win or away win, the corresponding team name will be displayed directly.</p>
              </div>
            </li>
            <li v-if="popupType == 'margin'">
              <div class="list_title">Confidence Index:</div>
              <div>
                <p>The five stars next to the team name indicate the algorithm's estimate of the likelihood of this prediction outcome, based on the different amounts and richness of data from various teams in the past. More stars suggest a higher probability of the predicted result occurring.</p>
              </div>
            </li>
            <li v-if="popupType == 'margin'">
              <div class="list_title">1x2:</div>
              <div>
                <p>The 1x2 displayed in the lower left corner is the main odds data referred to by the algorithm at the moment of prediction.</p>
              </div>
            </li>
            <li>
              <div class="list_title">Update Record:</div>
              <div>
                <p>Click on the "Updated" button in the bottom right corner to view the history of changes to all predictions. As our algorithm constantly adjusts to new data from bookmakers, the update time is a crucial indication.</p>
              </div>
            </li>
          </ul>
          <div class="img">
            <img v-if="isWeb == true && popupType == 'margin'" src="~@/assets/images/1x2_popup_margin_pc.png" />
            <img v-if="isWeb == true && popupType == 'divergence'" src="~@/assets/images/1x2_popup_divergence_pc.png" />
            <img v-if="isWeb == false && popupType == 'margin'" src="~@/assets/images/1x2_popup_margin_mb.png" />
            <img v-if="isWeb == false && popupType == 'divergence'" src="~@/assets/images/1x2_popup_divergence_mb.png" />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as echarts from "echarts"
export default {
  props: {
    detailInfo: {
      type: Object,
      default:null
    }, 
    relateMatch: {
      type: Array,
      default:null
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    match: {
      type: Object,
      default:null
    }, 
    setting: {
      type: Object,
      default: () => {}
    },
    relateLeague: {
      type: [Object,Array],
      default:null
    },
    
    logList: {
      type: Array,
      default:null
    }, 
  },
  data(){
    return{
      isDay: 1, //指数走势 1:天，0：24H
      isDown: false,
      isWeb: true,
      tipPopupShow: false,
      popupType: 'margin',
      pupHistoryShow: false
    }
  },
  methods: {
    // 登录传参
    onChangePop(val) {
      let eventName = 'LS_PC_H_Login';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_H_Login';
      }

      this.common.googleEvent(eventName, {
          '触发位置': '比赛内页1x2'
      });

      let _val = val;
      this.$emit('onChangLogin', _val);
    },

    // 关联比赛
    changeMatch(item){
      let eventName = 'LS_PC_MD_AdditionalMatches_Click';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_AdditionalMatches_Click';
      }
      this.common.googleEvent(eventName, {
        '玩法': this.langConfig.txtLang[this.langConfig.curLang]['PLAY_EVENT'][0]
      });

      let _homeName = this.common.formalTitle(item.homeTeam.fullName)
      let _awayName = this.common.formalTitle(item.awayTeam.fullName)
      if(this.$route.params.id != item.matchId) this.$router.push("/details/" +  this.$route.params.tab + '/' + item.matchId + '/' + _homeName + '-vs-' + _awayName);
    },
    // 指数返回
    oddsCallFn(ot, val, type){
      let _val = Number(val), _type = type;
      if(typeof(_val) == 'undefined'){
        return '-'
      }

      return this.oddsLuckyChange(ot, _val, _type);
    },

    // 赔率转换
    oddsLuckyChange(ot, val, type2){
      let _val = val, _form = this.setting.oddsFormRadio, _type = ot, _type2 = type2;
      let _typeArr = ['home', 'away', 'over', 'under'];

      // if(_type == 1){
      //   return this.common.oddsFromChange(_val, _form);
      // }

      if(_type == 2 || _type == 3){
        if(_typeArr.includes(_type2)){
          _val =  this.common.addValue(_val*1,1);
        }
      }
      if(_type2 == 'hand' || _type2 == 'total'){
        return _val;
      }

      return this.common.oddsFromChange(_val, _form);
    },

    getGameTime(startTime,_dateForm){
      var _tz = '+08:00'
      var _this=this;
      var setting=_this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tz=setting.tsz
      }

      var _time=this.common.dateStr(this.common.getDateByArray(_tz, startTime),_dateForm);
      
      var timeArr = _time.split(' ')
      timeArr[1] = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec"][timeArr[1]-1]
      _time = timeArr.join(' ')
      return _time;

    },

    // 获取更新时间
    getMatchTime(val,dateForm){
      let _val = val;
      let _tsz = this.setting.tsz;
      var setting=this.common.getCookie('setting');  
      // var _dateForm = 'dd MM YYYY HH:mm';
    
      if(setting!=null&&setting!=undefined&&setting){
        setting=JSON.parse(setting);
        _tsz=setting.tsz
      }

      let _time = this.common.getDateByArray(_tsz, _val);
      
      return this.common.dateStr(_time, dateForm);
    },

    changeType(val){
      this.isDay = val
      this.getLineInfo()
    },
    // 指数走势
    getLineInfo(){
      if(this.detailInfo == null || this.detailInfo.hasOwnProperty('wdlModel') == false || this.detailInfo.wdlModel.hasOwnProperty('oddsTrend') == false){
        return
      }
      this.$nextTick(() =>{
        let homeArr = []
        let drawArr = []
        let awayArr = []
        let timeArr = []
        let arr = this.isDay == 1 ? this.detailInfo.wdlModel.oddsTrend.day : this.detailInfo.wdlModel.oddsTrend.time
        
        for (let i = 0; i < arr.length; i++) {
          const ele = arr[i];
          if(this.setting.oddsFormRadio == 2){
            homeArr.push(Number(eval(this.oddsCallFn(1, ele.home, 'home')).toFixed(2)))
            drawArr.push(Number(eval(this.oddsCallFn(1, ele.draw, 'draw')).toFixed(2)))
            awayArr.push(Number(eval(this.oddsCallFn(1, ele.away, 'away')).toFixed(2)))
          }else{
            homeArr.push(this.oddsCallFn(1, ele.home, 'home'))
            drawArr.push(this.oddsCallFn(1, ele.draw, 'draw'))
            awayArr.push(this.oddsCallFn(1, ele.away, 'away'))
          }
          // console.log(homeArr,drawArr,awayArr)
          let time = ele.createTime.replace(/-/g,"/").split('.')[0]
          
          if(this.isDay == 1){
            // timeArr.push(this.getEchartTime(Math.floor(new Date(ele.createTime).getTime() / 1000, 'dd')))
            timeArr.push(this.getMatchTime(Math.floor(new Date(time).getTime() / 1000),'dd'))
          }else{
            timeArr.push(this.getMatchTime(Math.floor(new Date(time).getTime() / 1000),'HH:mm'))
          }
          // alert(timeArr)
        }
        this.lineEchart = echarts.init(this.$refs.lineEchart);
        let _this = this
        this.lineEchart.setOption({
          tooltip: {
            trigger: 'axis'
          },
          grid: {
            left: '0%',
            right: '4%',
            bottom: '0%',
            top: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(38, 38, 38, 0.8)',
            hideDelay: 800,
            borderWidth: 2,
            borderColor: '#595959',
            boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.3)',
            borderRadius: 5,
            textStyle: { // 提示框浮层的文本样式。
              color: '#fff',
              fontSize: 12,
            },
            padding: [14,32,14,12],
            confine: true,
            formatter: function(arg) {
              let ih = `<div style="font-weight: bold">${arg[0].name}${_this.isDay == 1 ? 'th' : ''}</div>`
              for (let i = 0; i < arg.length; i++) {
                const ele = arg[i];
                if(_this.setting.oddsFormRadio == 2){
                  ih += `<div>${ele.seriesName}: ${_this.oddsCallFn(1, (ele.value+1), (i == 0 ? 'home' : i == 1 ? 'draw' : 'away'))}</div>`
                }else{
                  ih += `<div>${ele.seriesName}: ${ele.value}</div>`
                }
              }
              return ih
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: timeArr
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'Home',
              type: 'line',
              data: homeArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#09B363'    //小圆点和线的颜色
              },
            },
            {
              name: 'Draw',
              type: 'line',
              data: drawArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#8C8C8C'    //小圆点和线的颜色
              },
            },
            {
              name: 'Away',
              type: 'line',
              data: awayArr,
              smooth: true,
              symbolSize: 5,
              symbol: 'circle',
              itemStyle: {
                color: '#EB3420'    //小圆点和线的颜色
              },
            },
          ]
        });
        this.lineEchart.resize();
      })
    },

    // 获取百分比
    percentageVal(a,b,num){
      if(a && b){
        return (((b/a) * 100).toFixed(num||0) || 0) + '%'
      }else{
        return '0%'
      }
    },

    // 获取场数
    getMatchNum(type){
      let winNum = 0
      let drawNum = 0
      let lossNum = 0
      for(let i = 0; i < this.detailInfo.wdlModel.matchLog.list.length; i++){
        let item = this.detailInfo.wdlModel.matchLog.list[i]
        if(item.res == 1) {winNum = winNum + 1}
        else if(item.res == 2) {drawNum = drawNum + 1}
        else if(item.res == 3) {lossNum = lossNum + 1}
      }
      
      if(type == 'win'){
        return winNum
      }else if(type == 'draw'){
        return drawNum
      }else if(type == 'loss'){
        return lossNum
      }
    },

    // 历史交锋-移动端展开
    down(){
      this.isDown = true;
    },

    // 历史交锋-获取球队名
    getTeamName(id){
      let match = this.detailInfo.match
      if(id == match.homeTeam.id){
        return match.homeTeam.shortName
      }else{
        return match.awayTeam.shortName
      }
    },
    // 历史交锋-获取状态
    getState(res,type){
      if(res == 3){
        return (type == 'class' ? 'state_3' : 'L')
      }else if(res == 2){
        return (type == 'class' ? 'state_2' : 'D')
      }else{
        return (type == 'class' ? 'state_1' : 'W')
      }
    },

    // 历史交锋图表数据处理
    getHistoryClashChart(){
      if(!this.detailInfo || this.detailInfo.hasOwnProperty('wdlModel') == false || this.detailInfo.wdlModel.hasOwnProperty('matchLog') == false || this.detailInfo.wdlModel.matchLog.list.length == 0){
        return
      }
      let val = {
        win: this.detailInfo.wdlModel.matchLog.win,
        draw: this.detailInfo.wdlModel.matchLog.draw,
        loss: this.detailInfo.wdlModel.matchLog.loss
      }
      let obj = {
        isShowTitle: false,
        title: '',
        winColor: '#09B363',
        drawColor: '#8C8C8C',
        lossColor: '#EB3420',

      }
      this.$nextTick(() =>{
      this.pieChart1('historyClash_chart',val,obj)
      })
    },

    pieChart1(dom,val,obj){
      var pieChart1 = echarts.init(this.$refs[dom]);
      pieChart1.setOption({ 
        tooltip: {
          trigger: 'none'  // 设置提示框触发方式为'none'，即不触发提示框
        },
        title: {
          text: obj.isShowTitle == false ? '' : obj.title,
          left: 'center', // 标题居中
          top: 'center',
          textStyle: {
            fontSize: 20, // 设置标题文字大小为20像素
            fontWeight: 'bold'
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              disable:true,
              scale:false,
              scaleSize:0,
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: val.loss, 
                name: '降',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.lossColor
                  }
                }
              },
              
              { 
                value: val.draw, 
                name: '稳',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.drawColor
                  }
                }
              },
              { 
                value: val.win, 
                name: '升',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.winColor
                  }
                }
              },
            ]
          }
        ]
      });
      pieChart1.resize();
    },

    // 指数公司升降统计-比较值大小
    getMaxNum(type){
      if(type == 'up'){
        let home = this.detailInfo.wdlModel.companyOddsStat.home.up
        let draw = this.detailInfo.wdlModel.companyOddsStat.draw.up
        let away = this.detailInfo.wdlModel.companyOddsStat.away.up
        return Math.max(home, draw, away)
      }else if(type == 'down'){
        let home = this.detailInfo.wdlModel.companyOddsStat.home.down
        let draw = this.detailInfo.wdlModel.companyOddsStat.draw.down
        let away = this.detailInfo.wdlModel.companyOddsStat.away.down
        return Math.max(home, draw, away)
      }else if(type == 'flat'){
        let home = this.detailInfo.wdlModel.companyOddsStat.home.flat
        let draw = this.detailInfo.wdlModel.companyOddsStat.draw.flat
        let away = this.detailInfo.wdlModel.companyOddsStat.away.flat
        return Math.max(home, draw, away)
      }
    },
    // 指数公司升降统计-处理指数百分比
    getOddsStat(type,num){
      if(type == 1){
        let homeUp = Math.floor(this.detailInfo.wdlModel.companyOddsStat.home.up)
        let homeDown = Math.floor(this.detailInfo.wdlModel.companyOddsStat.home.down)
        let homeFlat = Math.floor(this.detailInfo.wdlModel.companyOddsStat.home.flat)

        if((homeUp == 100 || homeDown == 100 || homeFlat == 100) || (homeUp == 0 && homeDown == 0 && homeFlat == 0)){
          return num == 1 ? homeUp : num == 2 ? homeDown : homeFlat
        }else{
          if(homeUp == 0 && homeDown != 0 && homeFlat != 0){
            homeFlat = 100 - homeDown
          }else if(homeUp != 0 && homeDown == 0 && homeFlat != 0){
            homeFlat = 100 - homeUp
          }else if(homeUp != 0 && homeDown != 0 && homeFlat == 0){
            homeDown = 100 - homeUp
          }else{
            homeFlat = 100 - homeUp - homeDown
          }
          return num == 1 ? homeUp : num == 2 ? homeDown : homeFlat
        }
      }else if(type == 2){
        let drawUp = Math.floor(this.detailInfo.wdlModel.companyOddsStat.draw.up)
        let drawDown = Math.floor(this.detailInfo.wdlModel.companyOddsStat.draw.down)
        let drawFlat = Math.floor(this.detailInfo.wdlModel.companyOddsStat.draw.flat)

        if((drawUp == 100 || drawDown == 100 || drawFlat == 100) || (drawUp == 0 && drawDown == 0 && drawFlat == 0)){
          return num == 1 ? drawUp : num == 2 ? drawDown : drawFlat
        }else{
          if(drawUp == 0 && drawDown != 0 && drawFlat != 0){
            drawFlat = 100 - drawDown
          }else if(drawUp != 0 && drawDown == 0 && drawFlat != 0){
            drawFlat = 100 - drawUp
          }else if(drawUp != 0 && drawDown != 0 && drawFlat == 0){
            drawDown = 100 - drawUp
          }else{
            drawFlat = 100 - drawUp - drawDown
          }
          return num == 1 ? drawUp : num == 2 ? drawDown : drawFlat
        }
      }else if(type == 3){
        let awayUp = Math.floor(this.detailInfo.wdlModel.companyOddsStat.away.up)
        let awayDown = Math.floor(this.detailInfo.wdlModel.companyOddsStat.away.down)
        let awayFlat = Math.floor(this.detailInfo.wdlModel.companyOddsStat.away.flat)

        if((awayUp == 100 || awayDown == 100 || awayFlat == 100) || (awayUp == 0 && awayDown == 0 && awayFlat == 0)){
          return num == 1 ? awayUp : num == 2 ? awayDown : awayFlat
        }else{
          if(awayUp == 0 && awayDown != 0 && awayFlat != 0){
            awayFlat = 100 - awayDown
          }else if(awayUp != 0 && awayDown == 0 && awayFlat != 0){
            awayFlat = 100 - awayUp
          }else if(awayUp != 0 && awayDown != 0 && awayFlat == 0){
            awayDown = 100 - awayUp
          }else{
            awayFlat = 100 - awayUp - awayDown
          }
          return num == 1 ? awayUp : num == 2 ? awayDown : awayFlat
        }
      }
    },
    // 指数公司升降统计图表数据处理
    getLiftStatisticsChart(){
      if(!this.detailInfo || this.detailInfo.hasOwnProperty('wdlModel') == false || this.detailInfo.wdlModel.hasOwnProperty('companyOddsStat') == false){
        return
      }
      let val1 = {
        win: this.detailInfo.wdlModel.companyOddsStat.home.up,
        draw: this.detailInfo.wdlModel.companyOddsStat.home.flat,
        loss: this.detailInfo.wdlModel.companyOddsStat.home.down
      }
      let obj1 = {
        isShowTitle: true,
        title: '1',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      
      this.$nextTick(() => {
        this.pieChart1('liftStatistics_chart1',val1,obj1)
      })

      let val2 = {
        win: this.detailInfo.wdlModel.companyOddsStat.draw.up,
        draw: this.detailInfo.wdlModel.companyOddsStat.draw.flat,
        loss: this.detailInfo.wdlModel.companyOddsStat.draw.down
      }
      let obj2 = {
        isShowTitle: true,
        title: 'X',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      this.$nextTick(() => {
        this.pieChart1('liftStatistics_chart2',val2,obj2)
      })

      let val3 = {
        win: this.detailInfo.wdlModel.companyOddsStat.away.up,
        draw: this.detailInfo.wdlModel.companyOddsStat.away.flat,
        loss: this.detailInfo.wdlModel.companyOddsStat.away.down
      }
      let obj3 = {
        isShowTitle: true,
        title: '2',
        winColor: '#E90C69',
        drawColor: '#8C8C8C',
        lossColor: '#414C9F',

      }
      this.$nextTick(() => {
        this.pieChart1('liftStatistics_chart3',val3,obj3)
      })
    },

    // 历史同指数图表数据处理
    getSameOddsHistoryChart(){
      if(!this.detailInfo || this.detailInfo.hasOwnProperty('wdlModel') == false || this.detailInfo.wdlModel.hasOwnProperty('sameOddsHistory') == false){
        return
      }
      let val1 = {
        val1: this.detailInfo.wdlModel.sameOddsHistory.home.hitCount,
        val2: this.detailInfo.wdlModel.sameOddsHistory.home.count,
      }
      let obj1 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlModel.sameOddsHistory.home.count,this.detailInfo.wdlModel.sameOddsHistory.home.hitCount,0),
        color1: '#09B363',
        color2: '#d9d9d9',
      }
      this.$nextTick(() => {
        this.pieChart2('sameOdds_chart1',val1,obj1)
      })

      let val2 = {
        val1: this.detailInfo.wdlModel.sameOddsHistory.draw.hitCount,
        val2: this.detailInfo.wdlModel.sameOddsHistory.draw.count,
      }
      let obj2 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlModel.sameOddsHistory.draw.count,this.detailInfo.wdlModel.sameOddsHistory.draw.hitCount,0),
        color1: '#8C8C8C',
        color2: '#d9d9d9',
      }
      this.$nextTick(() => {
        this.pieChart2('sameOdds_chart2',val2,obj2)
      })

      let val3 = {
        val1: this.detailInfo.wdlModel.sameOddsHistory.away.hitCount,
        val2: this.detailInfo.wdlModel.sameOddsHistory.away.count,
      }
      let obj3 = {
        isShowTitle: true,
        title: this.percentageVal(this.detailInfo.wdlModel.sameOddsHistory.away.count,this.detailInfo.wdlModel.sameOddsHistory.away.hitCount,0),
        color1: '#EB3420',
        color2: '#d9d9d9',
      }
      this.$nextTick(() => {
        this.pieChart2('sameOdds_chart3',val3,obj3)
      })
    },
    pieChart2(dom,val,obj){
      var pieChart2 = echarts.init(this.$refs[dom]);
      pieChart2.setOption({
        tooltip: {
          trigger: 'none'  // 设置提示框触发方式为'none'，即不触发提示框
        },
        title: {
          text: obj.isShowTitle == false ? '' : obj.title,
          left: 'center', // 标题居中
          top: 'center',
          textStyle: {
            fontSize: this.isWeb == true ? 16 : 12 // 设置标题文字大小为20像素
          }
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['60%', '100%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              disable:true,
              scale:false,
              scaleSize:0,
            },
            labelLine: {
              show: false
            },
            data: [
              { 
                value: val.val1, 
                name: '降',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.color1
                  }
                }
              },
              { 
                value: val.val2, 
                name: '升',
                itemStyle: {
                  normal: {
                    //这里是颜色
                    color: obj.color2
                  }
                }
              },
            ]
          }
        ]
      });
      pieChart2.resize();
    },

    showPopup(type){
      if(!this.tipPopupShow){
        let eventName = 'LS_PC_Help_Click';
        if(this.common.isMobile != 4){
            eventName = 'LS_Webapp_Help_Click';
        }

        let param = (type == 'margin' ? '比赛内页1x2-margin' : '比赛内页1x2-Divergence');

        this.common.googleEvent(eventName, {
            '点击位置': param
        });
      }

      this.popupType = type
      this.tipPopupShow = true
    },

    //获取屏幕宽度
    handleResize() {
      if(typeof window!='undefined'){
        this.isWeb=(window.innerWidth>767?true:false)
        if(this.lineEchart) this.lineEchart.resize()
        console.log('111');
        if(this.isLogin == true || this.match.state == 4){
          this.init()
        }
      }
    },

    changePup(type){
      this.$emit('changePup',type)
    },

    init(){
      let eventName = 'LS_PC_MD_1x2';
      if(this.common.isMobile != 4){
          eventName = 'LS_Webapp_MD_1x2';
      }
      this.common.googleEvent(eventName);
      
      this.getLineInfo()
      this.getHistoryClashChart()
      this.getLiftStatisticsChart()
      this.getSameOddsHistoryChart()
    }
  },
  mounted() {
    
    setTimeout(() => {
      this.handleResize();
    },100)

    this.$nextTick(() => {
      if(typeof window!='undefined'){
        window.addEventListener('resize', this.handleResize);
      }
    })
  },
  beforeDestroy() {
    if(typeof window!='undefined'){
      window.removeEventListener('resize', this.handleResize);
    }
  },
  watch:{
    isLogin:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val == true){
          this.init()
        }
      }
    },
    match:{
      immediate: true,
      deep: true,
      handler(val) {
        if(val.state == 4){
          this.init()
        }
      }
    },
    setting: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.isLogin == true || this.match.state == 4){
          this.init()
        }
      }
    },
    detailInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.isLogin == true || this.match.state == 4){
          this.init()
        }
      }
    }
  }
}
</script>
<style scoped lang="less"> 
  @import '1x2.less';  
</style>


// WEBPACK FOOTER //
// ./src/views/details/components/1x2.vue